// components
import { Icon } from '@sdb/planning-ui';
import Kbd from 'components/shared/Typography/Kbd/Kbd';

// types
import { PopoverActionProps } from './PopoverAction.types';

// styles
import {
  DisplayWrapper,
  IconWrapper,
  PopoverActionButton,
  TailWrapper
} from './PopoverAction.styles';
import { IconContainer } from 'components/mrp/mrp.styles';
import {
  getBeforeSeparatedItemStyling,
  getSeparatedItemStyling
} from '../../Popover.utils';

const PopoverAction = ({
  value,
  icon,
  forceIconSpace,
  shortcutHint,
  forceShortcutSpace,
  disabled,
  onClick,
  separated,
  roundedBottom
}: PopoverActionProps) => {
  return (
    <PopoverActionButton
      variant="text"
      disabled={disabled}
      onClick={onClick}
      sx={[
        separated ? getSeparatedItemStyling : {},
        roundedBottom ? getBeforeSeparatedItemStyling : {}
      ]}
    >
      {(icon || forceIconSpace) && (
        <IconWrapper>
          {icon && (
            <IconContainer iconSize="SMALL" iconColor={icon.iconColor}>
              <Icon type={icon.iconType} />
            </IconContainer>
          )}
        </IconWrapper>
      )}

      <DisplayWrapper>{value}</DisplayWrapper>

      {(shortcutHint || forceShortcutSpace) && (
        <TailWrapper>
          {shortcutHint && (
            <Kbd
              keys={[...shortcutHint.controllerKeys, shortcutHint.activatorKey]}
            />
          )}
        </TailWrapper>
      )}
    </PopoverActionButton>
  );
};

export default PopoverAction;
